import contactoHome from '../../img/contactanos.jpg';
import { Link } from 'react-router-dom';
const Contactanos = () => {
   return (
      // <div className="bg-latitud animated fadeIn" >
      //    <div className="container section">
      //       <div className="row">
      //          <div className="center-vertical">
      //             <div className="col s12 m12 l6 x6 center">
      //                <img src={contactoHome} className="circle responsive-img" height="300" width="300"/>
      //             </div>
      //             <div className="col s12  m12 l6  x6 center text-white">
      //                <strong style={{"font-size":"24px"}}>¡Contáctanos para todas tus consultas!</strong><br/><br/><br/>
      //                <Link to={"/contacto"} className="btn btn-large waves-effect waves-light text-gray  white pulse" type="submit" name="action">Ver más
      //                   <i className="material-icons right">send</i>
      //                </Link>
      //             </div>
      //          </div>
      //       </div>
      //    </div>
      // </div>
      <div className="section animated fadeIn" style={{ margin: '30px 0', padding: 0 }}>
         {/* BANNER INSTITUCIONAL DE CONTACTO - ANCHO COMPLETO */}
         <div className="card-panel bg-latitud z-depth-2" style={{ borderRadius: '0', padding: '50px 5%', backgroundColor: '#039be5', margin: 0 }}>
            <div className="row valign-wrapper" style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', margin: 0, maxWidth: '1400px', marginLeft: 'auto', marginRight: 'auto' }}>
               {/* IMAGEN CIRCULAR CON MARCO ELEGANTE */}
               <div className="col s12 m12 l5 x5 center-align" style={{ marginBottom: '25px' }}>
                  <div style={{ display: 'inline-block', padding: '10px', background: 'rgba(255, 255, 255, 0.15)', borderRadius: '50%', boxShadow: '0 8px 20px rgba(0,0,0,0.15)' }}>
                     <img 
                        src={contactoHome} 
                        alt="Contacto Latitud Sur" 
                        className="circle responsive-img" 
                        style={{ width: '260px', height: '260px', objectFit: 'cover', border: '4px solid #ffffff', display: 'block' }} 
                     />
                  </div>
               </div>
               {/* TEXTO Y BOTÓN DE ACCIÓN */}
               <div className="col s12 m12 l7 x7 white-text center-on-small-only" style={{ paddingLeft: '20px' }}>
                  <h4 style={{ fontWeight: '700', fontSize: '2.2rem', margin: '0 0 25px 0', lineHeight: '1.3', letterSpacing: '0.5px' }}>
                     ¡Contáctanos para todas tus consultas!
                  </h4>
                  <Link 
                     to={"/contacto"} 
                     className="btn waves-effect waves-light white grey-text text-darken-3 z-depth-1 hoverable" 
                     style={{ borderRadius: '6px', textTransform: 'none', fontWeight: '600', padding: '0 32px', height: '46px', lineHeight: '46px' }}
                  >
                     Ver más información
                     <i className="material-icons right" style={{ fontSize: '1.2rem', marginLeft: '6px' }}>mail</i>
                  </Link>
               </div>
            </div>
         </div>
      </div>
   )
}

export default Contactanos